<template>
  <div class="min-h-screen py-8">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      
      <!-- Header -->
      <div class="mb-8">
        <h1 class="text-3xl font-bold text-slate-900 dark:text-white">Governance Engine</h1>
        <p class="mt-2 text-slate-600 dark:text-slate-400">Security, Access Control, and Compliance Dashboard.</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        
        <!-- RBAC Section -->
        <div class="lg:col-span-2">
            <!-- Full width for tree -->
            <GovernanceRbacGraph />
        </div>

        <!-- PII Section -->
        <div class="lg:col-span-1">
             <GovernancePiiTagger />
        </div>

        <!-- Audit / Stats Section (Placeholder for now) -->
         <div class="bg-white dark:bg-slate-800 rounded-lg shadow p-6">
            <h2 class="text-xl font-semibold text-slate-800 dark:text-white mb-4">Security Audit</h2>
            <div class="space-y-4">
                <div class="flex items-center justify-between p-3 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 rounded-md border border-red-100 dark:border-red-800">
                    <div class="flex items-center">
                        <Icon name="heroicons:exclamation-triangle" class="w-5 h-5 mr-2" />
                        <span class="font-medium">2 Failed Logins</span>
                    </div>
                    <span class="text-xs">Last 1 hour</span>
                </div>
                 <div class="flex items-center justify-between p-3 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 rounded-md border border-green-100 dark:border-green-800">
                    <div class="flex items-center">
                        <Icon name="heroicons:check-circle" class="w-5 h-5 mr-2" />
                        <span class="font-medium">MFA Enforced</span>
                    </div>
                    <span class="text-xs text-green-600">Active</span>
                </div>
            </div>
         </div>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Page component
</script>
